﻿import React from 'react';
import classNames from 'classnames';
import { TextArea } from "@blueprintjs/core";
import PropTypes from 'prop-types';

import { FormHelperText } from "components/form-fields";

import 'components/form-fields/FormFields.css';
import { ShowHide } from 'components/layout';
import { Numeric } from 'components/formatting';

export function FormTextArea(
    {
        id = null,
        value = "",
        loading = false,
        headingText = "",
        helperText = null,
        disabled = false,
        dangerHelperText = null,
        placeholder = null,
        maxLength = null,
        showCounter = false,
        wide = false,
        fill = false,
        expandable = false,
        readOnly = false,
        inputRef,
        onChange
    }
) {

	return (
        <div className="form-field">
            <h4 className={classNames({ "bp6-skeleton": loading })}>{headingText}</h4>
            <FormHelperText loading={loading}>{helperText}</FormHelperText>
            <TextArea
				id={id}
				disabled={disabled}
				className={classNames("hide-in-print", { "bp6-skeleton": loading }, { "wide": wide }, { "expandable": expandable }, { "fill": fill })}
				onChange={onChange}
				maxLength={maxLength}
				value={value}
				placeholder={placeholder}
				inputRef={inputRef}
				readOnly={readOnly}
			/>
            <ShowHide
				evaluator={showCounter && maxLength != null}
				show={(
					<p className="hide-in-print form-text-counter">
						<Numeric>{value?.length ?? 0}</Numeric> / <Numeric>{maxLength}</Numeric>
					</p>
				)}
			/>
            <p className="show-in-print">{value}</p>
            <FormHelperText danger={true}>{dangerHelperText}</FormHelperText>
        </div>
    );
}

FormTextArea.propTypes = {
	id: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	loading: PropTypes.bool,
	headingText: PropTypes.string,
	helperText: PropTypes.node,
	disabled: PropTypes.bool,
	dangerHelperText: PropTypes.node,
	placeholder: PropTypes.string,
	maxLength: PropTypes.number,
	showCounter: PropTypes.bool,
	wide: PropTypes.bool,
	inputRef: PropTypes.object,
	fill: PropTypes.bool,
	expandable: PropTypes.bool,  /*only for internal use pages, because if set then it uses field-sizing which is not currently supported on safari or firefox*/
	readOnly: PropTypes.bool
};